(function () {

  const initDesktopSlider = () => {
    const desktopSliders = document.querySelectorAll('.featured-products-desktop-carousel__swiper');

    desktopSliders.forEach((slider) => {
      if (slider.swiper) return;

      new Swiper(slider, {
        navigation: {
          nextEl: slider.closest('.featured-products-desktop-carousel')
            ?.querySelector('.featured-products-desktop-carousel__button-next'),
          prevEl: slider.closest('.featured-products-desktop-carousel')
            ?.querySelector('.featured-products-desktop-carousel__button-prev'),
        },
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
        watchOverflow: true,
        breakpoints: {
          576: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          750: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1360: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          }
        },
        on: {
          init: function () {
            toggleNavVisibility(this);
            setTimeout(() => {
              equalizeSlideHeights(this.el);
            }, 100);
          },
          resize: function () {
            toggleNavVisibility(this);
            setTimeout(() => {
              equalizeSlideHeights(this.el);
            }, 100);
          },
          slideChange: function () {
            setTimeout(() => {
              equalizeSlideHeights(this.el);
            }, 50);
          }
        }
      });
    });
  };

  const destroyDesktopSlider = () => {
    const desktopSliders = document.querySelectorAll('.featured-products-desktop-carousel__swiper');

    desktopSliders.forEach((slider) => {
      if (slider.swiper !== undefined) slider.swiper.destroy();
    });
  };

  function toggleNavVisibility(swiperInstance) {
    const container = swiperInstance.el.closest('.featured-products-desktop-carousel');
    const nav = container?.querySelector('.featured-products-desktop-carousel__navigation');
    if (!nav) return;

    if (swiperInstance.isLocked) {
      nav.style.display = 'none';
    } else {
      nav.style.display = '';
    }
  }

  function equalizeSlideHeights(sliderElement) {
    const slides = Array.from(sliderElement.querySelectorAll('.swiper-slide'));
    if (slides.length === 0) return;

    let maxHeight = 0;
    slides.forEach(slide => { slide.style.height = 'auto'; });
    slides.forEach(slide => {
      const h = slide.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });
    slides.forEach(slide => { slide.style.height = maxHeight + 'px'; });
  }

  const initSection = () => {
    destroyDesktopSlider();
    initDesktopSlider();
  };

  initSection();

  document.addEventListener('DOMContentLoaded', initSection);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initSection, 200);
  });

})();
